import { Injectable } from '@angular/core';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WebSocketService {

  private socket$!: WebSocketSubject<any>;

  connect(url: string): void {
    this.socket$ = webSocket(url);
  }

  sendMessage(msg: any): void {
    this.socket$?.next(msg);
  }

  getMessages(): Observable<any> {
    return this.socket$.asObservable();
  }

  close(): void {
    this.socket$?.complete();
  }
}